import { useState } from "react";
import { Box, Stack } from "@storyofams/react-ui";
import Head from "next/head";
import { useRouter } from "next/router";
import { Modal } from "~components/common/Modal";
import { Share } from "~components/common/Share";
import { Circle } from "~components/recipe/Circle";
import { Author } from "./Author";
import { CartProvider } from "./CartProvider";
import { FooterRecipe } from "./Footer";
import { Gallery } from "./Gallery";
import { Header } from "./Header";
import { RecipeData } from "./RecipeData";
import { RecipeStructureData } from "./RecipeStructureData";
import { RelatedRecipes } from "./RelatedRecipes";

export const Recipe = ({ recipe }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [rating, setRating] = useState(null);
  const { asPath } = useRouter();
  return (
    <CartProvider>
      <Head>
        <link rel="preload" href={recipe.image} as="image" />
      </Head>
      <Box
        mb={["10px", "40px"]}
        width="100%"
        backgroundColor="white"
        borderRadius="0.5rem"
        border="1px solid grey200"
        position={"relative"}
      >
        <Stack
          p={["15px", "30px"]}
          space={[0, 0, "40px"]}
          flexDirection={["column", "column", "row"]}
          justifyContent="center"
          width="100%"
        >
          <Box
            order={[1, 0]}
            transition="width ease 0.5s"
            width={["100%", "100%", "50%", "50%"]}
            flexGrow={1}
          >
            <Box>
              <Box mb={["20px", "40px"]}>
                <Gallery recipe={recipe} />
              </Box>
              <Box display={["block", "none"]}>
                <Header
                  isDescription
                  recipe={recipe}
                  setRating={setRating}
                  bundleId={recipe.recipe_product_id}
                />
              </Box>
              <RecipeData recipe={recipe} />
            </Box>
          </Box>

          <Box
            order={[0, 1]}
            position={"relative"}
            transition="width ease 0.5s"
            width={["100%", "100%", "50%", "50%"]}
          >
            <Box top={[0, 150]} position={["relative", "sticky"]}>
              <Header
                recipe={recipe}
                setRating={setRating}
                bundleId={recipe.recipe_product_id}
              />
            </Box>
          </Box>
        </Stack>
        <Box id="ingredients" />
        <FooterRecipe
          url={`https://naturalheroes.nl${asPath}`}
          setIsOpen={setIsOpen}
          id={recipe.id}
        />
      </Box>
      <Author author={recipe.author_email} />
      <RelatedRecipes
        category={recipe.recipe_category?.id}
        id={recipe.id}
        featuredRecipes={recipe.featured_recipe}
      />
      <Circle
        content={{
          Space_slug: recipe.space_slug,
          Post_slug: recipe.post_slug,
          Active: recipe.space_slug && recipe.post_slug,
        }}
      />
      <Modal isOpen={isOpen} close={() => setIsOpen(false)}>
        <Box p={3}>
          <Share
            url={`https://naturalheroes.nl${asPath}`}
            title="Deel het recept"
          />
        </Box>
      </Modal>
      <RecipeStructureData
        name={recipe?.title?.text}
        description={recipe?.description?.text}
        video={recipe?.video_url}
        image={recipe?.image}
        author={recipe?.author}
        keywords={recipe?.keywords}
        recipeYield={recipe?.max_quantity}
        prepTime={`PT${recipe?.prep_time}M`}
        totalTime={`PT${recipe?.total_time}M`}
        recipeIngredient={recipe.products.map((item) => item.title)}
        datePublished={recipe?.created_at}
        recipeInstructions={recipe.recipes_steps
          .map(({ text_content, photo, name }) => {
            return { text: text_content.text, image: photo, name };
          })
          .filter(({ text }) => text)}
        aggregateRating={
          !!rating?.rating && {
            ratingValue: rating?.rating,
            ratingCount: rating?.reviews?.length,
          }
        }
        category={recipe.category?.text}
      />
    </CartProvider>
  );
};
